import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffLoginAsModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "StaffLoginAsModalContainer" */
      './StaffLoginAsModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
